import { createAction } from "@reduxjs/toolkit";
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["fetch"] = "rebookPolicy/fetch";
    ActionTypes["fetchSuccess"] = "rebookPolicy/fetchSuccess";
    ActionTypes["fetchError"] = "rebookPolicy/fetchError";
    ActionTypes["reset"] = "rebookPolicy/reset";
})(ActionTypes || (ActionTypes = {}));
export const actions = {
    fetch: createAction(ActionTypes.fetch, () => ({
        payload: {}
    })),
    fetchSuccess: createAction(ActionTypes.fetchSuccess, (rebookPolicy) => ({
        payload: { rebookPolicy }
    })),
    fetchError: createAction(ActionTypes.fetchError, (error) => ({
        payload: { error }
    })),
    reset: createAction(ActionTypes.reset, () => ({
        payload: {}
    }))
};
